var map = {
	"./char1.webP": 8210,
	"./char11.webP": 9289,
	"./char12.webP": 7836,
	"./char13.webP": 8079,
	"./char14.webP": 9090,
	"./char15.webP": 8829,
	"./char16.webP": 5744,
	"./char2.webP": 35,
	"./char21.webP": 2138,
	"./char22.webP": 8203,
	"./char23.webP": 1848,
	"./char24.webP": 8833,
	"./char25.webP": 4838,
	"./char26.webP": 5591,
	"./char3.webP": 4864,
	"./char31.webP": 5579,
	"./char32.webP": 1482,
	"./char33.webP": 5509,
	"./char34.webP": 3716,
	"./char35.webP": 8423,
	"./char36.webP": 8774,
	"./char4.webP": 8409,
	"./char5.webP": 2798,
	"./char6.webP": 7199
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6305;